import Oidc from 'oidc-client';

// define java script client for identity server 4
const config = {
    authority: process.env.REACT_APP_AUTH_URL, // replace with real auth link based on environment
    client_id: 'admin-portal',
    redirect_uri: `${window.location.origin}/callback`, // created callback file to finalize open ID loop
    response_type: 'id_token token',
    scope: 'openid profile internal_credential',
    post_logout_redirect_uri: window.location.origin // get current URL
};
const AuthenticationManager = new Oidc.UserManager(config);
AuthenticationManager.startSilentRenew();

// console.log("AuthenticationManager Config", config);

// export user manager
export default AuthenticationManager;
